import React from 'react';
import ProjectLink from 'common/containers/project_link';
import { MINI_PROJECT_SUBCAT_NAME } from 'pap/constants';

const Created1to1 = ({ creative, project }) => {
  const negotiationValue = parseFloat(project.one_to_one_negotiation_value);

  return (
    <div className="pap-created-1-1">
      <div className="row align-center">
        <div className="columns small-16 medium-10 large-7">
          <h2 className="text-success text-center">
            <i className="fa fa-check-circle" /><br/>
            { project.mini? MINI_PROJECT_SUBCAT_NAME : '1-to-1' }
            {' '}project created
          </h2>

          <h4>What happens next?</h4>

          <ul>
          {negotiationValue > 0 &&
            <li>{creative.username} will review your offer.</li>
          }

          {negotiationValue > 0?
            <li>{creative.username} will accept, decline, or counter your offer.</li>:
            <li>{creative.username} will provide a quote, or decline.</li>
          }

            <li>After you and {creative.username} agree on a price, you provide payment.</li>

            <li>Your project begins!</li>
          </ul>
          <ProjectLink project={project} linkTitle="View your project" className="btn btn-primary" />
        </div>
      </div>
    </div>);
};

export default Created1to1;



// WEBPACK FOOTER //
// ./pap/components/created_1_1.jsx